module.exports = __webpack_public_path__ + "img/logo_citex.fc83f4af.png";